const dupicate_values = (data) => {
  const flag = {};
  const unique = [];
  data.forEach((element) => {
    if (!flag[element.type]) {
      flag[element.type] = true;
      unique.push(element.type);
    }
  });
  return unique;
};
export const throw_list = (data) => {
  const list = [];
  const unique_values = dupicate_values(data);
  unique_values.forEach((element) => {
    const value = data
      .filter((_element) => _element.type === element)
      .map((__element) => __element.title);
    list.push({
      name: element,
      list: value,
    });
  });
  return list;
};

export const throw_by_index = (index, data, get) => {
  try {
    const _data = throw_list(data);
    const filter_index = _data[index];
    switch (get) {
      case "name":
        return filter_index?.name ? filter_index.name : null;
      case "list":
        return filter_index?.list ? filter_index.list : null;
      default:
        return null;
    }
  } catch (error) {
    console.log(error);
  }
};

export const get_length = (data) => {
  try {
    const _length = throw_list(data).length;
    return _length;
  } catch (error) {
    console.log(error);
  }
};

const get_unique_values = (data, type) => {
  const flag = {};
  const unique = [];
  data.forEach((element) => {
    if (!flag[element[type]]) {
      flag[element[type]] = true;
      // unique.push(element[type]);
      unique.push({
        val_title: element[type],
        value_def: element.defination, // you can customize this if needed
      });
    }
  });
  return unique;
};

export const get_comp_object = (data) => {
  try {
    // console.log(data);
    const list = [];
    const unique_values = dupicate_values(data);
    unique_values.forEach((element) => {
      const value = get_unique_values(data, "competency_title");
      const new_val = [];
      value.map((val) => {
        const def = data // unique value of comp
          .filter(
            (_element) =>
              _element.type === element && _element.competency_title === val.val_title
          )
          .map((__element) => __element.statement);
        if (def.length === 0) return false;
        const _tempDef = [];
        def.map((_def, _defId) => {
          return _tempDef.push({
            def: _def,
            ans: [
              { name: "0", value: false },
              { name: "1", value: false },
              { name: "2", value: false },
              { name: "3", value: false },
              { name: "4", value: false },
            ],
          });
        });
        return new_val.push({
          title: val.val_title,
          title_def: val.value_def,
          weight: 25,
          value: [
            { name: "basic", value: true },
            { name: "intermediate", value: false },
            { name: "advance", value: false },
            { name: "expert", value: false },
          ],
          def: _tempDef,
          // def_ans:[]
        });
      });
      list.push({
        comp_type: element,
        value: 50,
        list: new_val,
      });
    });
    return list;
  } catch (error) {
    console.log(error);
  }
};

export const getSurveyDataForOwner = (list) => {
  console.log(list);
};
